<template>
	<div class="content">
		<div class="wrapper wrapper-full-page">
			<div class="full-page login-page relative">
				<!--	 you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " -->
				<div class="flex-1 flex justify-center pt-28 mb-6">

					<div class="register mx-4 ">
						<!-- Register -->
						<div class="inline-block cursor-pointer mb-6" @click="$router.push({ name: 'Login' })">
							<IconArrow :sizeMultiplier_prop="1.5" :color_prop="hexColorTheme" direction_prop="left" />
							<span class="text-white text-sm ml-6">Back to Login Page</span>
						</div>

						<div class="card">
							<div class="card-header">
								<div class="flex justify-between items-center mb-4">
									<div class="text-white text-3.5xl">Register</div>
									<div class="text-xs text-theme cursor-pointer" @click="openBantuan()">Help</div>
								</div>
							</div>

							<div class="card-body">
								<div class="text-white text-xs mb-6">
									<div class="mb-1">
										Successfully register on JFXGOLD X, and you'll get:
									</div>
									<ul class="pl-4">
										<li class="mb-1">Digital Gold Participant Account (RPED)</li>
										<li class="mb-1">Primary Withdrawal Account</li>
										<li class="">Holder Identification Number (HIN)</li>
									</ul>
								</div>

								<div class="text-white mb-6">
									<div class="text-sm font-bold mb-2.5">How to Register/Create an Account?</div>
									<ol class="pl-4 text-xs mb-2.5">
										<li class="mb-2.5">
											Choose a physical gold broker as the party facilitating the transaction, then click register
										</li>
										<li class="mb-2.5">
											You will be redirected to the registration website of your selected broker, then fill out the
											required form (personal & address details, employment information, and supporting documents)
										</li>
										<li class="">Wait for your registration to complete verification</li>
									</ol>
								</div>

								<div>
									<div>
										<label for="perantaraPerdaganganRegister" class="text-xs text-white mb-3">
											Physical Gold Broker
										</label>
										<div class="flex flex--same-width gap-6">
											<div class="input-group-c mb-2">
												<select class="" id="perantaraPerdaganganRegister" v-model="perantaraPerdanganRegister">
													<option value="AbiKomoditiBerjangka">ABI Komoditi Berjangka</option>
												</select>
											</div>

											<div>
												<button type="button" class="btn-register btn c-btn-theme btn-block mb-4"
													@click="register()">REGISTER</button>
											</div>
										</div>
									</div>
								</div>
							</div>

						</div>

						<!-- Bantuan Register Modal -->
						<BantuanRegister ref="bantuanRegister" />

					</div>
				</div>

				<FooterLogin />

			</div>
		</div>
	</div>
</template>

<script>
import BantuanRegister from './components/BantuanRegister.vue'
import IconArrow from '../../components/icons/IconArrow.vue'
import FooterLogin from '../../components/FooterLogin.vue'

export default {
	name: 'Register',
	components: {
		BantuanRegister,
		IconArrow,
		FooterLogin
	},

	data() {
		return {
			publicPath: process.env.BASE_URL,
			hexColorTheme: getComputedStyle(document.documentElement).getPropertyValue('--color-theme'),

			perantaraPerdanganRegister: 'AbiKomoditiBerjangka', // AbiKomoditiBerjangka
		}
	},

	methods: {
		register() {
			if (this.perantaraPerdanganRegister == 'AbiKomoditiBerjangka') {
				if (process.env.NODE_ENV == 'development') {
					window.open('https://webreg-dev-v2.abicommodity.co.id', '_blank')
				} else {
					window.open('https://webreg.abicommodity.co.id/', '_blank')
				}
			}
		},

		openBantuan() {
			this.$refs.bantuanRegister.openModal()
		},
	}
}
</script>

<style scoped>
.login-page {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	/* full screen height minimum */
}

.full-page > .content {
	padding-top: 60px;
	padding-bottom: 50px;
}

.card {
	background-color: var(--grey-1-color);
	width: 100%;
}

.register {
	width: 45rem;
	min-width: 26.25rem;
	max-width: 45rem;
}

.card > * {
	padding-right: 1.75em;
	padding-left: 1.75em;
}

select {
	-webkit-appearance: caret;

	/* outline: none;
	border: none;
	padding: 0 1em;
	width: calc(100% - 1em);
	color: black;
	background-color: white;
	font-size: 0.75rem; */
}

.btn-register {
	height: 2.5rem;
}
</style>
